<template>
  <ModalDialog
    ref="dialog"
    title="Update Customer Price List"
    :submitting="submitting"
    submitTitle="Submit"
    icon="fa-money-check-edit-alt"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow label="Customer"><FormStaticLabel>{{customerName}}</FormStaticLabel></FormRow>
      <template v-if="!amendPriceList && !isAddingToPendingPriceRequest">
        <FormRow label="Schedule">
          <FormOption label="Now" name="scheduleType" setting="now" v-model="requestData.scheduleType" inline="true" />
          <FormOption label="Scheduled" name="scheduleType" setting="schedule" v-model="requestData.scheduleType" inline="true" />
        </FormRow>
        <FormRow label="Scheduled Date" v-if="requestData.scheduleType == 'schedule'">
          <FormDate field="scheduleStartDate" v-model="requestData.scheduleStartDate" />
        </FormRow>
        <FormRow label="Update Reason">
          <FormInputTextArea placeholder="Update Reason" v-model="requestData.requestReason" field="requestReason" />
        </FormRow>
      </template>
      <template v-if="amendPriceList">
        <FormRow><span class="font-italic">Amending a pricelist pending approval. Changes will be made to the pending price list</span></FormRow>
      </template>
      <template v-if="isAddingToPendingPriceRequest">
        <FormRow><span class="font-italic">Price list will be inserted into the pending price update request</span></FormRow>
      </template>

    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import { StockPriceTypes, CustomerOverrideTypes, CustomerOverrideLevelTypes, PriceListIntegrationTypes } from '@/store/types'

export default {
  name: "CustomerPriceListUpdateDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    customerName: String,
    contactId: Number,
    customerPriceListId: Number,
    customerPriceList: Object,
    updateListData: Array,
    priceGroupOverrideSettings: Array,
    amendPriceList: {
      type: Boolean,
      default: false
    },
    priceListIntegrationType: String
  },
  data() {
    return {
      dialogForm: {},
      requestData: {},
      submitting: false
    }
  },
  mounted() {
  },
  computed: {
    isAddingToPendingPriceRequest() {
      return this.priceListIntegrationType == PriceListIntegrationTypes.includePending
    }
  },
  methods: {
    show() {
      // Reset form
      this.requestData = {}
      this.dialogForm = { }
      this.submitting = false

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = {
        isScheduled: this.requestData.scheduleType == 'schedule',
        scheduleStartDate: this.requestData.scheduleStartDate,
        notes: this.requestData.notes,
        requestReason: this.requestData.requestReason,
        priceData: this.updateListData,
        priceGroupOverrideSettings: this.priceGroupOverrideSettings,
        priceListIntegrationType: this.priceListIntegrationType
      }

      if(!this.amendPriceList) {
        // Create as a new price list with a price request group
        this.$apiService.pricingService.createCustomerPriceList(this.$props.contactId, updateData)
        .then(response => {
          this.modalClosed(response.data.id)
          this.hide()
        })
        .catch(err => {
          this.$data.dialogForm = this.processFormResponse(err)
        })
        .finally(() => {
          this.$data.submitting = false
        })
      } else {
        // For pending-approval price lists, amend this one directly
        this.$apiService.pricingService.updateCustomerPriceList(this.$props.contactId, this.$props.customerPriceListId, updateData)
        .then(response => {
          this.modalClosed(response.data.id)
          this.hide()
        })
        .catch(err => {
          this.$data.dialogForm = this.processFormResponse(err)
        })
        .finally(() => {
          this.$data.submitting = false
        })
      }
    },
  }
}
</script>